import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogsUserForm } from 'src/models/catalogs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseService } from 'src/services/db.service';
import { RegisteredUser } from 'src/models/models';
import { RegisteredUsers } from 'src/models/interfaces'

@Component({
	selector: 'app-user-form',
	templateUrl: './user-form.component.html',
	styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent {

	public catalogs = CatalogsUserForm;
	public isLoading: boolean = false;
	public today:Date = new Date();
	public questionnaireForm: FormGroup = this.formBld.group({
		name: ['', [Validators.required]],
		nameCompany: ['', [Validators.required]],
		position: ['', [Validators.required]],
		email: ['', [Validators.required, Validators.email]],
		state: ['', [Validators.required]],
		economicSector: ['', [Validators.required]],
		businessActivity: ['', [Validators.required]],
		size: ['', [Validators.required]],
		services: ['', [Validators.required]],
		goods: ['', [Validators.required]],
		resources: ['', [Validators.required]]
	});

	constructor(
		public formBld: FormBuilder,
		private dbSrv: DatabaseService,
		private router: Router
	) {
	}

	valueOrder = (): number => {
		return 0;
	}

	get form() {
		return this.questionnaireForm.controls;
	}

	formatLabel(value: number) {
		return value + '%';
	}

	sendData() {
		this.isLoading = true;
	 	const registerUserData: RegisteredUsers = {
			name: this.questionnaireForm.value.name,
			position: this.questionnaireForm.value.position,
			email:this.questionnaireForm.value.email,
			company: {
				name: this.questionnaireForm.value.nameCompany,
				state: this.questionnaireForm.value.state,
				economicSector: this.questionnaireForm.value.economicSector,
				businessActivity: this.questionnaireForm.value.businessActivity,
				size: this.questionnaireForm.value.size,
				costPercentage: {
					services: this.questionnaireForm.value.services,
					goods: this.questionnaireForm.value.goods,
					resources: this.questionnaireForm.value.resources
				},
			},
			registrationDate: new Date()
		};
		const registerUser = new RegisteredUser('',registerUserData );
		this.dbSrv.add(registerUser).then(
			(userData) =>{
				this.router.navigate(['/questionnaire'], {
					queryParams:{
						data:btoa(JSON.stringify(
							{
								userId: userData.id.valueOf(),
								name: userData.data.name,
								email: userData.data.email.valueOf(),
								businessActivity: userData.data.company.businessActivity.valueOf(),
							}
						))
					}
				});
			}
		);
	}
}
